<ion-list lines="none">

  <ion-item>

    <ion-label>

      <div class="data">
        <yu-icon slot="start" name="calendar"></yu-icon>
        <p>{{ communication.dia | date: 'dd/MM/yyyy' }}</p>
      </div>

      @if (communication.local) {
        <div class="data">
          <yu-icon slot="start" name="map-pin"></yu-icon>
          <p>{{ communication.local }}</p>
        </div>
      }

      @if (communication.usuario) {
        <div class="data">
          <yu-icon slot="start" name="user"></yu-icon>
          <p>{{ communication.usuario }}</p>
        </div>
      }

      @if (communication.maquina) {
        <div class="data">
          <yu-icon slot="start" name="hammer"></yu-icon>
          <p>{{ communication.maquina }}</p>
        </div>
      }

      @if (communication.fecha_prevista_reparacion) {
        <div class="data">
          <yu-icon slot="start" name="calendar-check"></yu-icon>
          <p>{{ communication.fecha_prevista_reparacion | date : 'dd/MM/yyyy' }}</p>
        </div>
      }

    </ion-label>

    @if (communication.id_tipo === taskTypesEnum.communication && communication.id_subtipo !== communicationTypesEnum.chats) {
      <yu-button
        type="clear"
        size="small"
        color="info"
        (yuClick)="shareButton.emit()"
      >
        Compartir
        <yu-icon name="share-network"></yu-icon>
      </yu-button>
    }

  </ion-item>

</ion-list>

@if (communication.descripcion) {

  <ion-list class="detail-block description-block" lines="none">

    <ion-item class="no-lines">
      <ion-label>{{ communication.descripcion }}</ion-label>
    </ion-item>

  </ion-list>

}
